<template>
    <main id="content" class="content-default offres-content">
        <div class="container">
            <div class="relative-section">
                <div class="brecrump font-bai">
                    <router-link to="/">{{ $t("app.Home") }}</router-link> /
                    <b>{{ $t("app.Offer title") }}</b>
                </div>
            </div>
            <h1 class="font-balo font-bold">
                <span>{{ offers.length }}</span>
                {{ $t("app.Current Openings") }}
            </h1>
            <ul class="list-inline offres-list" v-if="offers.length > 0">
                <li
                    class="item-inline"
                    v-for="(item, index) in offers"
                    :key="index"
                >
                    <div class="offres-item font-bai">
                        <h3 class="font-balo font-bold">
                            {{ item.title.rendered }}
                        </h3>
                        <div class="date">
                            <i>{{ item.acf.offres_time }}</i>
                        </div>
                        <div class="des" v-html="item.content.rendered"></div>
                        <a
                            :href="item.acf.offres_link"
                            class="btn font-balo font-bold"
                            target="_blank"
                            >{{ $t("app.Apply") }}</a
                        >
                    </div>
                </li>
            </ul>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "OfferPage",
    mounted() {
        this.getOffers();
        let pageId = 259;
        if (this.lang === "en") {
            pageId = 497;
        }
        this.getPage(pageId).then(() => {
            setDescriptionPage(get(this.page, "acf.meta_description", ""));
        });
    },
    computed: {
        ...mapState({
            page: state => get(state, "app.page", {}),
            offers: state => get(state, "app.offers", []),
            lang: state => get(state, "app.lang", "fr")
        })
    },
    methods: {
        ...mapActions("app", ["getOffers", "getPage"])
    }
};
</script>
